/* =========================================================
   DOPAMEAN — "How we measure" expandable
   Finds the <h5> inside a .dpm-info-panel whose text reads "How we
   measure" (any case, trailing colon allowed), turns its text into a
   full-width toggle button with a + at the right end, and inserts the
   panel from <template id="DpmMeasureGuide">
   (snippets/dpm-measure-guide.liquid) right after it: the large diagram
   for this product and how each measurement is taken. The + turns into
   a − while open.
   ========================================================= */
(function () {
  var TRIGGER_TEXT = 'how we measure';

  function sound(id) {
    if (window.DopameanSound) window.DopameanSound.play(id);
  }

  function setOpen(btn, panel, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.classList.toggle('is-open', open);
    if (open) {
      panel.removeAttribute('inert');
    } else {
      panel.setAttribute('inert', '');
    }
  }

  function attach(scope) {
    var tpl = document.getElementById('DpmMeasureGuide');
    if (!tpl) return;
    scope.querySelectorAll('h5').forEach(function (h5) {
      if (h5.dataset.dpmGuideDone === '1') return;
      var text = (h5.textContent || '').trim().toLowerCase().replace(/[\s:]+$/, '');
      if (text !== TRIGGER_TEXT) return;
      h5.dataset.dpmGuideDone = '1';

      var panel = tpl.content.firstElementChild.cloneNode(true);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dpm-measure-guide__toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', panel.id);
      while (h5.firstChild) btn.appendChild(h5.firstChild);
      var icon = document.createElement('span');
      icon.className = 'dpm-measure-guide__icon';
      icon.setAttribute('aria-hidden', 'true');
      btn.appendChild(icon);
      h5.appendChild(btn);
      h5.classList.add('dpm-measure-guide__heading');
      h5.insertAdjacentElement('afterend', panel);

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        setOpen(btn, panel, open);
        sound(open ? 'accordion.open' : 'accordion.close');
      });
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.dpm-info-panel').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) init(e.target);
  });

  /* Re-run when product-info swaps content (variant change). */
  if (typeof MutationObserver !== 'undefined') {
    document.querySelectorAll('product-info').forEach(function (pi) {
      new MutationObserver(function () { init(pi); }).observe(pi, {
        childList: true,
        subtree: true,
      });
    });
  }
})();
